import {Step} from "./step";
import {BaseModel} from "./base-model";

export class Task extends BaseModel {

  protected static self = Task;

  workInstructionId : string;
  name : string;
  description: string;
  sequence: number;
  steps: Step[];

  // Remap procedure to workInstruction for REST API
  get procedureId() { return this.workInstructionId; }
  set procedureId(procedureId) { this.workInstructionId = procedureId; }

  public validate(): boolean {
    return true;
  }
}
